import * as React from 'react';

import { connectToDescriptors, IDescriptorProps } from '../сonnectToDescriptors';
import { InputsMultiple } from '../../components/InputsMultiple';
import { floorInputDescriptors } from '../../constants/descriptors';
import { TTypedThunkDispatch } from '../../types/thunk';
import { getOffersCount } from '../../actions/offersData';
import { updateTags } from '../../actions/filterTags';
import { debounce } from '@cian/newbuilding-utils';
import { DEFAULT_INPUT_TIMEOUT } from '../../constants/timeouts';

export interface IFloorInputProps extends IDescriptorProps<number> {
  getOffersCount(): void;
  updateTags(): void;
}

class FloorInputComponent extends React.Component<IFloorInputProps> {
  public getOffersCount = debounce(DEFAULT_INPUT_TIMEOUT, this.props.getOffersCount);

  public shouldComponentUpdate(nextProps: IFloorInputProps) {
    const { gte: nextGte, lte: nextLte } = this.getValue(nextProps);
    const { gte, lte } = this.getValue(this.props);

    return nextGte !== gte || nextLte !== lte;
  }

  public getValue = ({ jsonQuery: { floor } }: IFloorInputProps) => {
    const gte = floor && floor.value && floor.value.gte !== undefined ? floor.value.gte : '';
    const lte = floor && floor.value && floor.value.lte !== undefined ? floor.value.lte : '';

    return { gte, lte };
  };

  public render() {
    const { actionCreator, descriptors } = this.props;
    const { gte, lte } = this.getValue(this.props);
    const action = (type: 'gte' | 'lte') => (value: string) => {
      const numValue = value === '' ? undefined : parseFloat(value);
      actionCreator(descriptors[0])(numValue, type);
      this.props.updateTags();
      this.getOffersCount();
    };

    return (
      <InputsMultiple
        stack={[
          {
            placeholder: 'от',
            ['aria-label']: 'Минимальный этаж',
            value: gte,
            onChangeValue: action('gte'),
          },
          {
            placeholder: 'до',
            ['aria-label']: 'Максимальный этаж',
            value: lte,
            onChangeValue: action('lte'),
          },
        ]}
      />
    );
  }
}

function mapDispatchToProps(dispatch: TTypedThunkDispatch) {
  return {
    getOffersCount: () => {
      dispatch(getOffersCount());
    },
    updateTags: () => {
      dispatch(updateTags());
    },
  };
}

export const FloorInput = connectToDescriptors(floorInputDescriptors, mapDispatchToProps)(FloorInputComponent);
